import type { AuditMeta } from "../../hooks/useTenantSettings";
import { formatRelativeTime } from "../../lib/relativeTime";
import { colors, fontSize } from "../../lib/tokens";

interface Props {
  audit: AuditMeta | undefined;
  emails: Record<string, string>;
}

export function AuditFootnote({ audit, emails }: Props) {
  if (!audit) return null;
  const who = audit.updated_by ? emails[audit.updated_by] ?? null : null;
  const when = formatRelativeTime(audit.updated_at);

  let text: string;
  if (who) text = `editado por ${who} ${when}`;
  else if (audit.source !== "app") text = `${audit.source} ${when}`;
  else text = `editado ${when}`;

  return (
    <span style={{ display: "block", fontSize: fontSize.sm, color: colors.stoneSoft, marginTop: 4 }}>
      {text}
    </span>
  );
}
